var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-framework";
var DialogClientService = /** @class */ (function () {
    function DialogClientService() {
        this.stack = [];
        this._showFuncs = [];
        this._hideFuncs = [];
    }
    Object.defineProperty(DialogClientService.prototype, "isModalVisible", {
        get: function () {
            return this.stack.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogClientService.prototype, "view", {
        get: function () {
            return this.stack.length > 0 ? this.stack[this.stack.length - 1].view : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DialogClientService.prototype, "model", {
        get: function () {
            return this.stack.length > 0 ? this.stack[this.stack.length - 1].model : null;
        },
        enumerable: false,
        configurable: true
    });
    DialogClientService.prototype.subscribeShow = function (funcShow, key) {
        if (key === void 0) { key = "default"; }
        this._showFuncs.push({ key: key, func: funcShow });
    };
    DialogClientService.prototype.unSubscribeShow = function (showFunc, key) {
        if (key === void 0) { key = "default"; }
        var func = this._showFuncs.filter(function (x) { return x.key == key && x.func == showFunc; })[0];
        var index = this._showFuncs.indexOf(func);
        if (index > -1) {
            this._showFuncs.splice(index, 1);
        }
    };
    /**
     * To show an Dialog box
     *
     * @param view
     * @param model
     * @param canHide
     * @param showCloseButton
     * @param fullscreen
     * @param key
     * @param hideOnOutsideClick if its true then auto close the dialog when we click outside overlay area
     */
    DialogClientService.prototype.show = function (view, model, canHide, showCloseButton, fullscreen, key, hideOnOutsideClick) {
        var e_1, _a;
        if (canHide === void 0) { canHide = true; }
        if (showCloseButton === void 0) { showCloseButton = false; }
        if (fullscreen === void 0) { fullscreen = false; }
        if (key === void 0) { key = "default"; }
        if (hideOnOutsideClick === void 0) { hideOnOutsideClick = true; }
        if (this.isModalVisible && this.view == view) {
            this.hide(true, key);
        }
        var stackData = {
            view: view,
            model: model,
            key: key,
            _canHide: canHide,
            showCloseButton: showCloseButton,
            fullscreen: fullscreen,
            hideOnOutsideClick: hideOnOutsideClick
        };
        this.stack.push(stackData);
        try {
            for (var _b = __values(this._showFuncs.filter(function (x) { return x.key == key; }).map(function (x) { return x.func; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                var func = _c.value;
                func(view, model, showCloseButton, fullscreen, hideOnOutsideClick);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    // HIDE DIALOG FUNCTIONS
    DialogClientService.prototype.subscribeHide = function (funcHide, key) {
        if (key === void 0) { key = "default"; }
        this.unSubscribeHide(funcHide, key);
        this._hideFuncs.push({ key: key, func: funcHide });
    };
    DialogClientService.prototype.unSubscribeHide = function (funcHide, key) {
        if (key === void 0) { key = "default"; }
        var func = this._hideFuncs.filter(function (x) { return x.key == key && x.func == funcHide; })[0];
        var index = this._hideFuncs.indexOf(func);
        if (index > -1) {
            this._hideFuncs.splice(index, 1);
        }
    };
    DialogClientService.prototype.hide = function (forceHide, key, closeAll) {
        var _this = this;
        if (forceHide === void 0) { forceHide = true; }
        if (key === void 0) { key = "default"; }
        if (closeAll === void 0) { closeAll = false; }
        var stackKey = this.stack.filter(function (x) { return x.key == key; });
        var func = function () {
            lastItem = stackKey[stackKey.length - 1];
            if (!lastItem._canHide && !forceHide)
                return;
            var lastItem = _this.stack.pop();
            if (!lastItem) {
                return;
            }
            var hideFuncs = _this._hideFuncs.filter(function (x) { return x.key == key; }).map(function (x) { return x.func; });
            var length = hideFuncs.length;
            for (var index = length - 1; index >= 0; index--) {
                var func = hideFuncs[index];
                func(lastItem.view, lastItem.model);
            }
            _this.blur();
        };
        if (stackKey.length > 0) {
            if (closeAll) {
                while (stackKey.length > 0) {
                    func();
                    stackKey = this.stack.filter(function (x) { return x.key == key; });
                }
            }
            else {
                func();
            }
        }
    };
    DialogClientService.prototype.blur = function () {
        var activeElement = document.activeElement;
        if (activeElement && activeElement.blur) {
            activeElement.blur();
        }
    };
    DialogClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [])
    ], DialogClientService);
    return DialogClientService;
}());
export { DialogClientService };
